import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { connect } from 'react-redux'
import { customerNameById, formatKennitala, formatKennitalaAsDate } from '../../utils'
import { closeModal } from '../../api/gui/actions'
import Tab from 'react-bootstrap/Tab'
import TabContainer from 'react-bootstrap/TabContainer'
import TabContent from 'react-bootstrap/TabContent'
import Nav from 'react-bootstrap/Nav'


class SigningModal extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {
        const { signingUrl } = this.props

        return (
            <Modal
                isOpen={this.props.gui.signingModals[this.props.id]}
                contentLabel={this.props.title}
            >
                { this.props.title &&
                    <h5>{this.props.title}</h5>
                }  
                <button onClick={() => this.props.dispatch(closeModal(this.props.id))} className="close-button" data-close aria-label="Loka glugga" type="button">
                    <span aria-hidden="true">&times;</span>
                </button>

                { signingUrl !== undefined &&

                    <iframe className="h-100 w-100" src={signingUrl} />
                }
            </Modal>
        )
    }
}

SigningModal.defaultProps = {
    title: "",
}

function mapStateToProps(state) {

    var f = {
        gui: {},
    }
    f.gui = (state.gui === undefined) ? {} : state.gui
    return f;
}

export default connect(mapStateToProps)(SigningModal);